import dayjs from "dayjs";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

export const EmiTenureModel = (
  loanBalance,
  emiAmt,
  tenure,
  roi,
  applicationNum,
  effectiveDate
) => {
  return {
    loanBalance: loanBalance,
    emiAmt: emiAmt,
    tenure: tenure,
    roi: roi,
    applicationNum: applicationNum,
    effectiveDate: effectiveDate,
  };
};

export const ProcessScheduleHistoryModel = (val, userName) => {
  const branchCodeValue = getSelectedBranchCode(val.branch);
  return {
    applicationNum: val.applicationNum,
    branch: val.branch,
    branchCode: branchCodeValue,
    customerName: val.customerName,
    effectiveDate: val.effectiveDate,
    loanBalance: val.loanBalance,
    currentEmiAmt: val.currentEmi,
    currentTenure: val.currentTenure,
    revisedEmiAmt: convertEmiToNumber(val.revisedEmi),
    revisedTenure: val.revisedTenure,
    roi: val.rateOfInterest,
    reasonForReschedule: val.reason,
    createdBy: userName,
    lastModifiedBy: userName,
  };
};

export const processChangeHeaderModel = (val, ecd, fedd) => {
  return {
    applicationNum: val.applicationNum,
    roi: val.rateOfInterest,
    emiAmt: convertEmiToNumber(val.revisedEmi),
    processType: "DB",
    tenure: val.revisedTenure,
    occuranceNum: 1,
    effectiveDate: (Date.parse(new Date(val.effectiveDate)) / 1000) * 1000,
    ecd: ecd,
    fedd: fedd,
  };
};

export const amountFormatter = (value) => {
  return parseInt(value).toLocaleString("en-IN");
};

export const convertEmiToNumber = (emiValue) => {
  return Number(emiValue.replace(/[^0-9.-]+/g, ""));
};

export const getSelectedBranchCode = (branchValue) => {
  const branchWithCodes = GetBranchDetailsWithCode();
  const branchCodeValue = branchWithCodes.find((branch) => {
    return branch.label === branchValue;
  });
  return branchCodeValue.code;
};

export const earlierReschedulementGridData = [
  {
    field: "id",
    headerName: "S.No",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    flex: 1,
    type: "string",
    editable: false,
  },
  {
    field: "effectiveDate",
    headerName: "Effective Date",
    headerAlign: "center",
    align: "center",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
    valueGetter: (params) =>
      dayjs(params.row.effectiveDate).format("DD/MM/YYYY"),
  },
  {
    field: "loanAmt",
    headerName: "Loan Balance (₹)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
    valueGetter: (params) => amountFormatter(params.row.loanAmt),
  },
  {
    field: "currentEmiAmt",
    headerName: "Current EMI (₹)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
    valueGetter: (params) => amountFormatter(params.row.currentEmiAmt),
  },
  {
    field: "revisedEmiAmt",
    headerName: "Revised EMI (₹)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
    valueGetter: (params) => amountFormatter(params.row.revisedEmiAmt),
  },
  {
    field: "currentTenure",
    headerName: "Current Tenure (Months)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
  },
  {
    field: "revisedTenure",
    headerName: "Revised Tenure (Months)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
  },
  {
    field: "roi",
    headerName: "Rate of Interest (%)",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
  },
  {
    field: "reasonForReschedule",
    headerName: "Reason For ReSchedulement",
    headerAlign: "center",
    align: "right",
    minWidth: 200,
    flex: 1,
    type: "string",
    editable: false,
  },
];
